var wFlag=true
if(window.innerWidth<750){
    wFlag=false
}

function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

$(()=>{
    setTimeout(() => {
        $('.box1_title').addClass('showup')
    }, 200);

    //box1_1
    var $video = $('#box1Video');
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box1_1',
            start:'top top+=6%',
            end:'+=120%',
            pin:true,
            scrub:true,
            // markers:true,
            onUpdate:(self)=>{
                //$video[0].duration
                $video[0].currentTime = self.progress * 4.4;
            }
        })
    }else{
        $video.attr('autoplay','autoplay')
        $video[0].play()
    }

    //box2
    showUp('.box2_text')
    showUp('.box2_item div:first-child img:nth-child(2)')
    ScrollTrigger.create({
        trigger:'.box2',
        start:'top center-=10%',
        end:wFlag?'+=90%':'+=50%',
        // toggleActions:'play none none reverse',
        scrub:1,
        // markers:true,
        animation:gsap.timeline()
            .from('.box2_item div:nth-child(n+2)',{y:'2rem',opacity:0,stagger:0.2})
    })
    
    //box3
    showUp('.box3_title')
    ScrollTrigger.create({
        trigger:'.box3_items',
        start:'top bottom-=20%',
        end:'+=40%',
        scrub:1,
        // markers:true,
        animation:gsap.timeline().to('.box3_items div',{xPercent:0,x:0,opacity:1})
    })

    //box4
    ScrollTrigger.create({
        trigger:'.box4',
        start:wFlag?'top top+=20%':'top top+=30%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline().from('.box4_img',{y:0})
    })
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=4%',
            end:'+=40%',
            pin:true
        })
    }
    
    //box5
    showUp('.box5_content')
    ScrollTrigger.create({
        trigger:'.box5',
        start:'top top+=8%',
        end:'+=40%',
        pin:true,
        scrub:1,
        // markers:true,
        animation:gsap.timeline().from('.box5_img img:last-child',{opacity:0})
    })
    
    //box6
    showUp('.box6_flag')
    
    //box7
    showUp('.box7_title')

    //box8
    showUp('.box8_title')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box8Swiper',
            start:'top bottom-=20%',
            end:'+=30%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline().to('.box8Swiper .swiper-wrapper .swiper-slide',{xPercent:0,x:0,opacity:1})
        })
    }else{
        new Swiper('.box8Swiper', {
            autoplay: true,
            slidesPerView: 4,
            centeredSlides: true,
        })
    }
    
    //box9
    showUp('.box9_title')
    var $video9 = $('#box9Video');
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box9',
            start:'top top+=12%',
            end:'+=120%',
            pin:true,
            scrub:true,
            // markers:true,
            onUpdate:(self)=>{
                //$video9[0].duration
                $video9[0].currentTime = self.progress * 3.04;
            }
        })
    }else{
        $video9.attr('autoplay','autoplay')
        $video9[0].play()
    }

    //box10
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box10',
            start:'top top+=4%',
            end:'+=60%',
            pin:true,
            scrub:1,
            animation:gsap.timeline()
                .to({},{duration:0.1})
                .from('.box10_mask',{scale:34,y:'120%',duration:0.5})
                .from('.box10_title',{opacity:0,y:'2rem',duration:0.2})
                .to({},{duration:0.2})
        })
    }else{
        showUp('.box10_title')
    }
    
    //box11
    showUp('.box11_title')

    ScrollTrigger.create({
        trigger:'.box11',
        start:'top+=30% top+=4%',
        end:'+=10%',
        // markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            // console.log(index)
            $('.box11_items2').toggleClass('showup',index>30)
            $('.box11_tip').toggleClass('showup',index>30)
            if(index>10){
                // 执行一次
                if(timeFlag2){
                    startTime2()
                    timeFlag2=false;
                }
            }else{
                // 重置
                timeFlag2=true,num2 = 0
            }
        }
    })

    ScrollTrigger.create({
        trigger:'.box11',
        start:'top+=70% top+=4%',
        end:'+=10%',
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            if(index>10){
                $('.box11_items2 .box11_item div p:nth-child(1)').hide()
                $('.box11_items2 .box11_item div p:nth-child(2)').show()
                // 执行一次
                if(timeFlag3){
                    startTime3()
                    timeFlag3=false;
                }
            }else{
                $('.box11_items2 .box11_item div p:nth-child(2)').hide()
                $('.box11_items2 .box11_item div p:nth-child(1)').show()
                // 重置
                timeFlag3=true,num3 = 0
            }
        }
    })

    ScrollTrigger.create({
        trigger:'.box11',
        start:wFlag?'top top+=4%':'top top+=8%',
        end:'+=100%',
        pin:true,
    })

    var num2 = 0,timeFlag2=true,IntervalFlag2;
    function startTime2(){
        IntervalFlag2 =  setInterval(() => updateInfo2(), 30);
    }
    function updateInfo2(){
        num2++;
        $(`.box11_items2 .box11_item div:nth-child(1) p:nth-child(1) span c`).text(`$${num2}`)
        if(num2 > 31){
            clearInterval(IntervalFlag2);
        }
    }

    var num3 = 0,timeFlag3=true,IntervalFlag3;
    function startTime3(){
        IntervalFlag3 =  setInterval(() => updateInfo3(), 30);
    }
    function updateInfo3(){
        num3++;
        $(`.box11_items2 .box11_item div:nth-child(1) p:nth-child(2) span c`).text(`$${468+num3}`)
        if(num3 > 31){
            clearInterval(IntervalFlag3);
        }
    }

    //box9_1
    new Swiper('.box9_1Swiper', {
        autoplay: {
            delay: wFlag?2000:1500,
            disableOnInteraction: false,
        },
        slideToClickedSlide: true,
        centeredSlides: true,
        slidesPerView:wFlag?5:1.5,
        loop:true
    })

    //box13
    showUp('.box13_title')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box13Swiper',
            start:'top bottom-=20%',
            end:'+=40%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline().to('.box13Swiper .swiper-slide',{x:0,opacity:1})
        })
        $('.box13_item').hover(function(){
            $('.box13_item video').each(function() {
                this.pause();
            });
            $(this).find('video')[0].play();
        })
    }else{
        new Swiper('.box13Swiper', {
            slidesPerView: 1.5,
            centeredSlides: true,
            autoplay:true,
            on:{
                slideChangeTransitionEnd: function(){
                    $('.box13_item video').css({filter:'brightness(0.4)'})
                    $('.box13_item video').each(function() {
                        this.pause();
                    });
                    $('.box13Swiper .swiper-slide-active .box13_item video').css({filter:'none'})
                    $('.box13Swiper .swiper-slide-active .box13_item video')[0].play()
                },
            },
        })
    }

    //boxSpecs_btn
    $('.bs_btn').click(function(){
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_buy').click(function(){ 
        // window.open(''); 
    })

    $('.pnr_spec').click(function(){
        $('.Mpn_popup').css({height:'0'})
        buyFlag = true
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_over2').click(function(){
        $('.Mpn_popup').css({height:'0'})
        buyFlag = true
        $('.classic_section2').hide()
        $('.classic_section1').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
    })
})